export default {
  GAMING: 'Gaming (Slots, Table Games, Poker Play)',
  ENTERTAINMENT: 'Entertainment (Dining, Shopping, Hotel Stays)',
  TR_VISA: 'Caesars Rewards Visa® Card',
  TR_MARKETPLACE:
    'Caesars Rewards Alliances (Caesars Rewards Marketplace, Caesars Casino)',
  PROMOTIONS: 'Promotions',
  ADJUSTMENTS: 'Other (Adjustments, Voided Comps)',
  CAESARS_SPORTSBOOK_APP: 'Caesars Sportsbook App',
};
